module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Rectangle-f29b89d089871ec246b2a9f4a5dee4f4.svg";